import { make, dispatch } from 'vuex-pathify'
import BookingFlowService from '../../services/booking-flow/service';

const getDefaultState = () => {
  return {
    products: {
      airportparking: [],
      airporthotel: [],
      airportlounge: [],
      addon: []
    },
    airport: {},
    request: {},
    status: '',
    quote: '',
    filters: {
      parkType: '',
      terminal: ''
    },
    sortBy: 'price-low',
    requotedHotel: false,
    editedProduct: false
  }
}

// initial state
const state = getDefaultState();

const actions = {
  ...make.actions(state),
  async getResults(context, modifier = "") {
    
    this.state.results = getDefaultState();

    await BookingFlowService.results(this.state.quote, modifier).then(response => {
      
      this.state.quote.quoteID = response.data['quote'];
      dispatch('cart/resetCart')

      context.dispatch('setProducts', response.data['products']);
      context.dispatch('setAirport', response.data['airport']);

      window.dataLayer = window.dataLayer || [];
      
      // eslint-disable-next-line no-undef
      dataLayer.push({
        'event': 'results',
        'resultsAirport': response.data['airport'].airport_name || '',
        'resultsDateA': this.state.quote.dateA || '',
        'resultsDateB': this.state.quote.dateB || '',
      });

      // BookingFlowService.quoteCounter({
      //   'departure_date': this.state.quote.dateA + ' ' + this.state.quote.timeA + ':00',
      //   'return_date': this.state.quote.dateB + ' ' + this.state.quote.timeB + ':00',
      //   'category': this.state.quote.category,
      //   'airport_id': response.data['airport'].airport_id,
      //   'agent': this.state.quote.agent,
      //   'promo': this.state.quote.promo,
      //   'quote': this.state.quote.quoteID,
      //   'session_id': this.state.quote.quoteID,
      //   'ip_address': '',
      //   'url': window.location.pathname,
      //   'browser': navigator.userAgent,
      //   'airportparking': response.data['products']['airportparking'] || [],
      //   'airportlounge' : response.data['products']['airportlounge'] || [],
      //   'addon' : response.data['products']['addon'] || [],
      //   'airporthotel' : response.data['products']['airporthotel'] || []
      // }, "silent").then(response => console.log(response))

      if(this.state.quote.category === 'airporthotel' && !response.data['products'][this.state.quote.category]) {
        
        dispatch('quote/setCategory', 'airportparking')
        dispatch('quote/setAgent', 'ONLINE')

        BookingFlowService.results(this.state.quote, modifier).then(response => {
          
          if(response.data['products']['airportparking'] && response.data['products']['airportparking'].length > 0) {
            context.dispatch('setRequotedHotel', true);
            context.dispatch('setProducts', response.data['products']);
          }
        })
      }

    }).catch(() => {
      this.state.results = getDefaultState();
    });
  },
  async getModifiedResult(context, quote) {

    context.dispatch('setEditedProduct', false);

    await BookingFlowService.results({ ...this.state.quote, timeA: quote.timeA, timeB: quote.timeB }, "")
    .then(response => {

      let product = response.data['products'].airportparking.find(product => product.park_id === quote.product)
      if(product) context.dispatch('setEditedProduct', product);

    }).catch((e) => {
      // eslint-disable-next-line
      console.log('error:', e);
    });
  },
  async revealPromo(context, payload) {
    await BookingFlowService.revealPromo(payload, "")
    .catch((e) => {
      // eslint-disable-next-line
      console.log('error:', e);
    });
  },
  async saveForLater(context, payload) {
    await BookingFlowService.saveForLater(payload, "")
    .catch((e) => {
      // eslint-disable-next-line
      console.log('error:', e);
    });
  },
  resetModify(context) {
    context.dispatch('setEditedProduct', false);
  }
};

const getters =  {
  ...make.getters(state),
  pageTitle(state) {
    return `${(state.airport && state.airport.airport_name) ? `${state.airport.airport_name}` : ''}`
  },
  promoActive(state) {
    if(!state.products.airportparking) return false
    return state.products.airportparking.filter(p => p.discount > 0 || p.promo_hidden == 1).length > 0;
    
  },
  promoInvalid(state) {
    if(!state.products.airportparking) return false
    return state.products.airportparking.filter(p => p.discount > 0 || p.promo_hidden == 1).length < 1;
  }
}

const mutations = make.mutations(state);

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};